import { render, staticRenderFns } from "./AxCard.vue?vue&type=template&id=5e82682e&scoped=true"
import script from "./AxCard.vue?vue&type=script&lang=ts"
export * from "./AxCard.vue?vue&type=script&lang=ts"
import style0 from "./AxCard.vue?vue&type=style&index=0&id=5e82682e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e82682e",
  null
  
)

export default component.exports